import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import PropTypes, { func } from 'prop-types';
import { Spacer, FieldSet, Legend, FormHelp, LabeledControl, Label, Radio } from '@zillow/constellation';
import { useFormContext, useFormState } from 'react-hook-form';

/**
 *
 */
function RadioField(_ref) {
  var _proxyFormState$error;
  var label = _ref.label,
    options = _ref.options,
    name = _ref.name,
    config = _ref.config,
    description = _ref.description,
    _onChange = _ref.onChange,
    disabled = _ref.disabled,
    required = _ref.required;
  var form = useFormContext();
  var proxyFormState = useFormState();
  var error = proxyFormState === null || proxyFormState === void 0 || (_proxyFormState$error = proxyFormState.errors[name]) === null || _proxyFormState$error === void 0 ? void 0 : _proxyFormState$error.message;
  var field = form.register(name, config);
  return /*#__PURE__*/React.createElement(Spacer, {
    marginBottom: "xs"
  }, /*#__PURE__*/React.createElement(FieldSet, {
    legend: /*#__PURE__*/React.createElement(Legend, null, label),
    description: /*#__PURE__*/React.createElement(FormHelp, {
      error: Boolean(error)
    }, error || description || /*#__PURE__*/React.createElement(React.Fragment, null, "\xA0")),
    disabled: disabled,
    required: required,
    error: Boolean(error)
  }, options && options.map(function (option) {
    return /*#__PURE__*/React.createElement(LabeledControl, _extends({
      onChange: function onChange(e) {
        field.onChange(e);
        _onChange === null || _onChange === void 0 || _onChange(e);
      }
    }, field, {
      key: option.label,
      label: /*#__PURE__*/React.createElement(Label, null, option.label),
      control: /*#__PURE__*/React.createElement(Radio, {
        name: label,
        value: option.value
      })
    }));
  })));
}
RadioField.propTypes = process.env.NODE_ENV !== "production" ? {
  label: PropTypes.string.isRequired,
  description: PropTypes.node,
  name: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  required: PropTypes.bool,
  config: PropTypes.shape({
    required: PropTypes.string,
    validate: PropTypes.oneOfType([PropTypes.shape({}), PropTypes.func])
  }),
  onChange: PropTypes.func,
  options: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired
  })).isRequired
} : {};
RadioField.defaultProps = {
  description: undefined,
  config: undefined,
  disabled: undefined,
  required: false,
  onChange: func
};

export { RadioField as default };
